/**
 * Responsible for activating the first report when an assessment is clicked
 */
export default function activateFirst() {
    const assessments = $('.side-nav .collapsible > li');
    assessments.each((index, assessment) => {
        assessment = $(assessment);
        const reports = assessment.find('li a');

        if(reports.length === 1) {
            const href = reports.attr('href');
            assessment.click(evt => {
                window.location.href = href;
                return false;
            });
        }
    });
}